'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.howlerNodeStub = exports.htmlMediaErrorMap = exports.howlerErrorCodeMap = exports.howlerEvents = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _htmlMediaEvents = require('../constants/htmlMediaEvents');

var _htmlMediaEvents2 = _interopRequireDefault(_htmlMediaEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/goldfire/howler.js/#onevent-function-id
var howlerEvents = exports.howlerEvents = {
  load: 'load',
  loaderror: 'loaderror',
  playerror: 'playerror',
  play: 'play',
  end: 'end',
  pause: 'pause',
  stop: 'stop',
  mute: 'mute',
  volume: 'volume',
  rate: 'rate',
  seek: 'seek',
  fade: 'fade',
  unlock: 'unlock'
};

// https://github.com/goldfire/howler.js/#onloaderror-function
// https://html.spec.whatwg.org/multipage/media.html#mediaerror
var howlerErrorCodeMap = exports.howlerErrorCodeMap = {
  1: {
    mediaError: 'MEDIA_ERR_ABORTED',
    isNetworkError: true
  },
  2: {
    mediaError: 'MEDIA_ERR_NETWORK',
    isNetworkError: true
  },
  3: {
    mediaError: 'MEDIA_ERR_DECODE',
    isNetworkError: false
  },
  4: {
    mediaError: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
    isNetworkError: true
  }
};

var htmlMediaErrorMap = exports.htmlMediaErrorMap = (0, _defineProperty3.default)({}, _htmlMediaEvents2.default.stalled, {
  type: _htmlMediaEvents2.default.stalled,
  isNetworkError: true
});

var howlerNodeStub = exports.howlerNodeStub = {
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {}
};
//# sourceMappingURL=constants.js.map